/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:0 0 auto}.brand-image-container[_ngcontent-%COMP%]{zoom:1}.brand-image-container-md[_ngcontent-%COMP%]{zoom:.8}.cc-header-icon[_ngcontent-%COMP%]{margin-left:4px;margin-right:4px;justify-content:center}.cc-header-brand-icon[_ngcontent-%COMP%]{min-height:35px!important;max-height:50px!important}"];
export { styles as styles };
